// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1GfBH","icon":"SortAdornment_icon__hApOQ","up":"SortAdornment_up__2IQuv","down":"SortAdornment_down__3geSq","active":"SortAdornment_active__doVCs"};